import React from "react";
import { useTransition, animated } from "@react-spring/web";

interface FadeSlideSwitcherProps {
	children: React.ReactNode;
	switchKey: React.Key;
}

// Matches Flutter's Curves.easeOut (cubic)
const easeOutCubic = (t: number): number => 1 - Math.pow(1 - t, 3);

export const FadeSlideSwitcher: React.FC<FadeSlideSwitcherProps> = ({ children, switchKey }) => {
	const transitions = useTransition(children, {
		key: switchKey,
		from: { opacity: 0, transform: "translateY(30%)" },
		enter: { opacity: 1, transform: "translateY(0%)" },
		leave: { opacity: 0, transform: "translateY(30%)" },
		config: { duration: 350, easing: easeOutCubic },
	});

	return transitions((style, item) => <animated.div style={style}>{item}</animated.div>);
};

export default FadeSlideSwitcher;
